export default __webpack_public_path__ + "static/aroundH4c2-49d970058c4788656a4549271ff4c77d.png";